{
	"showButtonTitle": "Afficher",
	"hideButtonTitle": "Masquer"
}
